import Model from './model.js';

export default {
    ReadAsMaster: function(params) {
        if(params.action === 'TENANT_SETTING') {
            params.data.query = 'Tenant/Config/';
        } else if(params.action ===  'SITE_TYPE') {
            params.data.query = 'Master/SiteTypes/';
        } else if(params.action === 'ASSET_STATUS') {
            params.data.query = 'Master/AssetsStatus/';
        } else if(params.action === 'CURRENCY') {
            params.data.query = 'Master/Currencies/All/';
        } else {
            params.data.query = 'User/Roles/';
        }
        Model.ReadAsMaster(params);
    },
    Update: function(params){
        Model.Update(params);
    }

}


// WEBPACK FOOTER //
// ./src/App/master/tenant_setting/presenter.js